import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";
import { Award, Globe2, Layers, Building2 } from "lucide-react";
import SectionHead from "@/components/SectionHead";
import { Reveal } from "@/components/Reveal";

function Counter({ to, suffix = "" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [v, setV] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const start = performance.now();
    const dur = 1500;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / dur);
      setV(Math.round(to * (1 - Math.pow(1 - p, 3))));
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }, [inView, to]);
  return (
    <span ref={ref} data-testid="stat-counter-years">
      {v}
      {suffix}
    </span>
  );
}

const CARDS = [
  { icon: Award, value: <Counter to={9} suffix="+" />, label: "Years of Recruitment Experience", id: "experience" },
  { icon: Globe2, value: "PAN India", label: "Recruitment Coverage", id: "coverage" },
  { icon: Layers, value: "IT + Non-IT", label: "Hiring Expertise", id: "expertise" },
  { icon: Building2, value: "MNC & Fortune 500", label: "Client Experience", id: "clients" },
];

export default function Stats() {
  return (
    <section data-testid="stats-section" className="relative py-24">
      <div className="mx-auto max-w-7xl px-6">
        <SectionHead overline="Credibility" title="Recruitment Expertise Built on Experience." testid="stats-heading" />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {CARDS.map((c, i) => (
            <Reveal key={c.id} delay={i * 0.1}>
              <div
                data-testid={`stat-card-${c.id}`}
                className="group relative h-full overflow-hidden rounded-2xl border border-white/[0.08] bg-[#0A0F1D]/80 p-7 transition-[border-color,transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:border-sky-400/30 hover:shadow-[0_20px_60px_rgba(56,189,248,0.08)]"
              >
                <div className="absolute -right-8 -top-8 h-24 w-24 rounded-full bg-sky-400/[0.06] blur-2xl transition-opacity duration-500 group-hover:opacity-100" />
                <c.icon size={22} className="mb-6 text-sky-400" />
                <p className="font-display text-2xl font-bold tracking-tight text-white sm:text-3xl">{c.value}</p>
                <p className="mt-2 text-sm text-slate-400">{c.label}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
